<template>
  <div class="common-page commission-sharing-rule-config">
    <div class="right-box" v-loading="loading">
      <div class="right-content">
        <div class="config-list">
          <div class="config-list-title">
            <div class="config-list-title-txt">
              <span>基础信息配置</span>
            </div>
            <div class="config-list-title-btns">
              <template v-if="isEdit">
                <el-button type="text" @click="isEdit = false">取消</el-button>
                <el-button type="text" @click="handleSave4()">保存</el-button>
              </template>
              <template v-else>
                <el-button type="text" @click="isEdit = true">编辑</el-button>
              </template>
            </div>
          </div>
          <el-row :gutter="20" class="form-box">
            <el-form ref="form4" :model="form" :rules="rules" label-position="top">
              <el-col :span="6">
                <el-form-item label="发票费率：" prop="invoiceRate">
                  <el-input :disabled="!isEdit" clearable placeholder="请输入" v-model="form.invoiceRate">
                    <div slot="append">%</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="客服电话：" prop="customerServicePhone">
                  <el-input
                    :disabled="!isEdit"
                    clearable
                    placeholder="请输入"
                    maxlength="11"
                    v-model="form.customerServicePhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="吨方规则（1吨）：" prop="tis">
                  <el-input :disabled="!isEdit" clearable placeholder="请输入" v-model="form.tis">
                    <div slot="append">方</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="运力上限计算系数：" prop="ask">
                  <el-input :disabled="!isEdit" clearable placeholder="请输入" v-model="form.ask"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div class="config-list">
          <div class="config-list-title">
            <div class="config-list-title-txt">
              <span>收款二维码</span>
            </div>
          </div>
          <div class="form-box">
            <div class="qr-box">
              <el-image :src="qrInfo.qr" class="qr-image" v-if="qrInfo.qr" :preview-src-list="[qrInfo.qr]"></el-image>
<!--              <div-->
<!--                class="qr-tip"-->
<!--                @click="-->
<!--                exportImage(qrInfo.qr, '收款码')-->
<!--              ">-->
<!--                点击下载收款码-->
<!--              </div>-->
              <el-upload
                ref="upload"
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="handleChange"
                :before-upload="beforeAvatarUpload"
                :limit="1">
                <slot>
                  <div style="margin-top: 30px">
                    <el-button type="default" icon="el-icon-plus" :loading="loading1">点击上传</el-button>
                  </div>
                </slot>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import {
  getConfig, getPaymentQr, postPaymentQr,
  setConfig
} from "./api";
import { validatePrice, validatePhone } from "@/utils/validate";
import {uploadFile} from "@/views/commonApi";
export default {
  name: "BasicBusinessRuleConfig",
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      qrInfo: {},
      form: {
        "ask": "", // 运力上线
        "customerServicePhone": "", // 客服电话
        "invoiceRate": "", // 发票费率
        "tis": "" // 吨方规则
      },
      isEdit: false,
      loading: false,
      loading1: false,
      rules: {
        ask: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        customerServicePhone: [
          { required: true, message: "不能为空" },
          { validator: validatePhone, trigger: "blur" },
        ],
        invoiceRate: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        tis: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ]
      },
    };
  },
  created() {
    this.getConfig();
    this.getQrInfo();
  },
  mounted() {},
  methods: {
    // 图片上传之前的
    beforeAvatarUpload(file) {
      return true
    },
    handleChange(file, fileList) {
      this.uploadFiles(file);
    },
    uploadFiles(file) {
      let files = file.file;
      let formData = new FormData();
      formData.append("file", files);
      this.loading1 = true
      uploadFile(formData)
          .then((res) => {
            if (res.code === 200) {
              this.$refs.upload.clearFiles();
              this.setQr(res.data);
            }
          }).finally(()=>{
        this.loading1 = false
      })

    },
    setQr(data) {
      postPaymentQr({
        "fileId": data.fileId,
        "filename": data.filename,
      })
          .then((res) => {
            if (res.code === 200) {
              this.getQrInfo();
            }
          }).finally(()=>{
        this.loading1 = false
      })
    },
    getQrInfo() {
      getPaymentQr().then((res) => {
        if (res.code === 200) {
          this.qrInfo = res.data;
          if (res.data.qr) {
            this.qrInfo.qr =
                "data:image/png;base64," + res.data.qr;
          }
        }
      });
    },
    // base64格式的图片
    dataURLtoBlob(dataurl) {
      let arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = window.atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    // 将blob对象转化成文件并导出到本地
    saveAs(blob, filename) {
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },

    // 将base64格式的图片下载到本地
    exportImage(base64Str, filename) {
      let blob = this.dataURLtoBlob(base64Str);
      this.saveAs(blob, filename);
    },
    getConfig() {
      this.loading = true;
      getConfig()
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            if (res.data.zydList && res.data.zydList.length > 0) {
              res.data.zydList.forEach((item) => {
                item.isEdit = false;
              });
            }
            if (
              res.data.rebateCompanies &&
              res.data.rebateCompanies.length > 0
            ) {
              res.data.rebateCompanies.forEach((item) => {
                item.isEdit = false;
              });
            }
            this.form = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSave4() {
      // this.isEdit = false;
      this.$refs.form4.validate((valid) => {
        if (valid) {
          this.setRebateDriverConfigData();
          // this.form.box1[index].isEdit = false;
        } else {
          return false;
        }
      });
    },
    setRebateDriverConfigData() {
      setConfig({
        ask: this.form.ask,
        customerServicePhone: this.form.customerServicePhone,
        invoiceRate: this.form.invoiceRate,
        tis: this.form.tis,
      }).then((res) => {
        if (res.code === 200) {
          this.isEdit = false;
          this.$message.success("保存成功");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.commission-sharing-rule-config {
  display: flex;
  flex-direction: row;
  .qr-box {
    width: 1.5rem;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .qr-image {
      width: 1.5rem;
      height: 1.5rem;
    }
    .qr-tip {
      font-size: 0.12rem;
      color: #1269ff;
      padding-top: 0.1rem;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .left-box {
    width: 20%;
    height: 100%;
    //background-color: #ffffff;
    flex-shrink: 0;
    padding: 0.2rem 0 0.2rem 0.2rem;
    box-sizing: border-box;
    .left-content {
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      border-radius: 0.08rem;
      padding: 0.2rem;
      box-sizing: border-box;
      overflow-y: auto;
      .list {
        width: 100%;
        height: 0.4rem;
        color: #434343;
        display: flex;
        align-items: center;
        padding-left: 0.1rem;
        box-sizing: border-box;
        font-size: 0.16rem;
        cursor: pointer;
        border-radius: 0.04rem;
      }
      .select-dispatch {
        background: rgba(18, 105, 255, 0.05);
        color: #1269ff;
        position: relative;
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: "";
          width: 0.02rem;
          height: 100%;
          background-color: #1269ff;
        }
      }
    }
  }
  .right-box {
    flex: 1;
    padding: 0 0.2rem 0.2rem;
    box-sizing: border-box;

    .right-content {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #ffffff;
      border-radius: 0.08rem;
      padding: 0.1rem;
      box-sizing: border-box;
      .config-list {
        border-bottom: 0.01rem solid #dce5f5;
        padding-bottom: 0.1rem;
        margin-bottom: 0.1rem;
      }
      .config-list:nth-last-of-type(1) {
        border-bottom: none;
      }
    }
    .config-list-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 0.1rem;
      padding-top: 0.1rem;
      .config-list-title-txt {
        span:nth-of-type(1) {
          color: #000000;
          font-size: 0.16rem;
        }
        span:nth-of-type(2) {
          color: #8c8c8c;
          font-size: 0.12rem;
          padding-left: 0.1rem;
        }
      }
      .config-list-title-btns {
      }
    }
  }
  .form-box1 {
    padding: 0.1rem 0.1rem 0.2rem;
    .form-box-item-title {
      background: #f0f5ff;
      height: 0.32rem;
      display: flex;
      align-items: center;
      color: #000000;
      font-size: 0.14rem;
      .dot {
        position: relative;
        &:before {
          position: absolute;
          content: "*";
          color: red;
          left: -0.1rem;
          top: 0.04rem;
        }
      }
    }
    .form-box-item-content {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.5rem;
      .content-list {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        ::v-deep .el-form-item {
          margin-bottom: 0;
        }
      }
    }
    .form-box-item-content:nth-of-type(2n-1) {
      background: #fbfcff;
    }
  }
}
</style>
